
  import React from "react"
  import Component from "C:/Users/Website Sketchers/project/Problub-UI/src/layouts/index.jsx"
  import data from "C:\\Users\\Website Sketchers\\project\\Problub-UI\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js